import React, {Component} from 'react';
import SignIn from "./SignIn";
import ForgotPassword from "./ForgotPassword";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import AccountRecovery from "./AccountRecovery";
import {Registration} from "./Registration";
import {connect} from "react-redux";
import {authPoll, authStateChange, createCompany, joinCompany, login} from "../../actions/ui";
import CompanyProfilePublic from "../Settings/CompanyProfilePublic";
import {TermsOfUse} from "./TermsOfUse";
import {Button} from "antd";

class _Authenticator extends Component {
  componentDidMount() {
    this.props.onMount && this.props.onMount();
  }

  renderSignedOut() {
    const { authState, authData } = this.props;
    return (
      <div>
        <SignIn
          authState={authState}
          authData={authData}
          onLogin={this.props.onLogin}
          onStateChange={this.props.onStateChange}
        />
        <div>
          <div style={{
            width: 570,
            height: 140,
            backgroundColor: '#e5ebf3',
            border: '1px solid #3365a0',
            padding: '7px',
            position: 'absolute',
            top: 23,
            left: 'calc(50% - 285px)',
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ textAlign: 'center', marginTop: -6 }}>
              <h2 style={{ color: 'rgba(0, 0, 0, 0.65)' }}>New updates for cProject</h2>
              <span>We have updated cProject. Please <a onClick={() =>
                this.props.onStateChange('forgotPassword')}>create a new password</a> to log in, unless you
                have already done so since the update on December 1, 2020.</span>
              <Button
                type='primary' htmlType='submit' className='full-width' style={{ maxWidth: 345, marginTop: 6 }}
                onClick={() => this.props.onStateChange('forgotPassword')}
              >Click Here to Create a New Password</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderForgotPassword() {
    const { authState, authData } = this.props;
    return (
      <div>
        <ForgotPassword
          authState={authState}
          authData={authData}
          onStateChange={this.props.onStateChange}
        />
      </div>
    );
  }

  renderAccountRecovery = (...props) => {
    return (
      <div>
        <AccountRecovery {...props} />
      </div>
    );
  };

  renderRegistration = state => props => <Registration state={state} onStateChange={this.props.onStateChange} {...props} />;

  renderAuthenticator = () => {
    const {
      authState,
      profile,
      onCreateCompany,
      onJoinCompany,
      children
    } = this.props;
    switch (authState) {
      case 'signedOut':
        return this.renderSignedOut();
      case 'forgotPassword':
        return this.renderForgotPassword();
      case 'beginUserRegistration':
      case 'registrationInProgress':
      case 'pendingCompanyAccept':
        return <Registration state={authState} onCreate={onCreateCompany} onJoin={onJoinCompany}/>;
      case 'signedIn':
        if (profile && profile.acceptedtermsofservice === false) {
          return <React.Fragment>
            <TermsOfUse/>
            {children}
          </React.Fragment>
        }
        return <React.Fragment>
          {children}
        </React.Fragment>;
      default:
        return (<div>
          Loading...
        </div>);
    }
  };

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/recovery/:sid" component={this.renderAccountRecovery}/>
          <Route path="/registration/:sid" component={this.renderRegistration('beginUserRegistration')}/>
          <Route path="/@/:company" component={CompanyProfilePublic}/>
          <Route component={this.renderAuthenticator}/>
        </Switch>
      </BrowserRouter>
    )
  }
}

export const Authenticator = connect(
  (state, props) => ({
    authState: state.ui.authState,
    authData: state.ui.authData,
    profile: state.profile,
  }),
  (dispatch, props) => ({
    onMount: () => dispatch(authPoll()),
    onStateChange: (authState, authData) => dispatch(authStateChange(authState, authData)),
    onCreateCompany: (company) => dispatch(createCompany(company)),
    onJoinCompany: (company) => dispatch(joinCompany(company)),
    onLogin: (username, password) => dispatch(login(username, password))
  })
)(_Authenticator);



// WEBPACK FOOTER //
// ./src/components/Security/Authenticator.js